module.exports = __webpack_public_path__ + "static/media/img_online.c0a796d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_online.jpg
// module id = 421
// module chunks = 4